/** 收益总览页 **/
<template>
  <div class="home">
    <Layout type="REVENUE" isRevenue="true" :pageTitle="$t('menu.taskStatus')">
      <Overview></Overview>
      <DeviceDetail class="overview-device-detail"></DeviceDetail>
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Layout from '@/components/DatePanel/Layout.vue'
import Overview from '@/components/Device/Overview.vue'
import DeviceDetail from '@/components/Device/DeviceDetail.vue'


export default {
  name: 'home',
  components: {
    Header,
    Layout,
    Overview,
    DeviceDetail
  },
}
</script>

<style  lang="stylus">
.data-panel-wrap, .data-panel-layout, .home {
  height: 100%;
}

.overview-device-detail{
  margin-top: 30px;
}
</style>

